import Page from '../Page';
import LoadingIndicator from '../components/LoadingIndicator';
import RankingRulesCard from '../components/RankingRulesCard';
import {useEffect, useState} from 'preact/hooks';
import {useLocation} from 'preact-iso';
import {listAutoSortCollections, SORT_ORDER_LABELS} from '../../../../shared/models/collection-sort';
import {collectionPath} from '../productRoutes';

export default function CollectionsPage() {
  const location = useLocation();
  const [collections, setCollections] = useState([]);
  const [status, setStatus] = useState('loading');
  const [error, setError] = useState('');

  useEffect(() => {
    listAutoSortCollections().then(setCollections)
      .catch((e) => setError(e instanceof Error ? e.message : 'Unable to load collections.'))
      .finally(() => setStatus('idle'));
  }, []);

  const chooseCollection = async () => {
    const selected = await shopify.resourcePicker({type: 'collection', multiple: false, action: 'select'});
    if (selected?.[0]?.id) location.route(collectionPath(selected[0].id));
  };

  return (
    <Page heading="Collections">
      <s-button slot="primary-action" variant="primary" onClick={chooseCollection}>Preview sort</s-button>
      {error && <s-banner tone="critical">{error}</s-banner>}
      <s-section heading="Sorted automatically">
        {status === 'loading' ? <LoadingIndicator label="Loading collections" /> : collections.length ? (
          <s-table>
            <s-table-header-row><s-table-header listSlot="primary">Collection</s-table-header><s-table-header listSlot="labeled">Products</s-table-header><s-table-header listSlot="labeled">Sort order</s-table-header></s-table-header-row>
            <s-table-body>{collections.map((collection) => (
              <s-table-row key={collection.id}>
                <s-table-cell><s-link tone="neutral" href={collectionPath(collection.id)} onClick={(event) => { event.preventDefault(); location.route(collectionPath(collection.id)); }}><s-text>{collection.title}</s-text></s-link></s-table-cell>
                <s-table-cell>{collection.productsCount.count}</s-table-cell>
                <s-table-cell>{SORT_ORDER_LABELS[collection.sortOrder] || collection.sortOrder}</s-table-cell>
              </s-table-row>
            ))}</s-table-body>
          </s-table>
        ) : <s-stack alignItems="center" gap="base" padding="large-400"><s-heading>No collections are sorted automatically</s-heading><s-paragraph>Preview a collection's sort, then turn on automatic sorting from its preview.</s-paragraph><s-button onClick={chooseCollection}>Preview sort</s-button></s-stack>}
      </s-section>
      <RankingRulesCard />
    </Page>
  );
}
